<div class="mb-4">
    <label for="anexos" class="form-label">Anexos</label>
    <div class="d-flex gap-2 align-items-center ">
        <select [title]="!pacienteId ? 'Selecione um paciente' : 'Adicionar um novo arquivo'"
            [disabled]="!pacienteId" name="tipoAnexo" class="form-control" id="tipoAnexo"
            [(ngModel)]="newAnexo.tipoArquivoProntuario">
            <option [value]="undefined">Selecione o tipo do arquivo</option>
            <option *ngFor="let tipo of tipoArquivo.list" [value]="tipo.type">{{ tipo.name }}</option>
        </select>

        <input type="file" #file accept="image/jpeg, image/png, application/pdf" style="display: none;"
            (change)="onFilesSelected($event.target.files)" multiple="false" autocomplete="off" />

        <button [disabled]="!newAnexo.tipoArquivoProntuario"
            [title]="newAnexo.tipoArquivoProntuario ? 'Anexar Arquivos' : 'Selecione o tipo do arquivo'" type="button"
            class="btn icon icon-edit mx-2" (click)="file.click()">
            <i class="hgi hgi-stroke hgi-add-01"></i>
        </button>
    </div>
</div>
<div *ngIf="anexosAtuais.length > 0" class="arquivos-container scroll-container ">
    <div *ngFor="let anexo of anexosAtuais" class="row d-flex align-items-center mt-2 anexos-list">
        <div class="col-auto">
            {{anexo.arquivo.nome}}.{{anexo.arquivo.extensaoArquivo}}
        </div>
        <div class="col d-flex justify-content-end">
            <button *ngIf="showDeletedButton(anexo)" class="btn icon icon-danger" title="Remover anexo"
                (click)="removerAnexo(anexo)">
                <i class="hgi hgi-stroke hgi-delete-02"></i>
            </button>
            <button *ngIf="showDownloadButton(anexo)" class="btn icon icon-ligth-blue ml-2" title="Realizar download"
                (click)="downalodFile(anexo)">
                <i class="hgi hgi-stroke hgi-download-05"></i>
            </button>
        </div>
    </div>
</div>